// client/src/dnd/emitter_tool/runtime/Runtime_Parts/GlowRegistry.js
import { getRootContainer, findFogHoles } from "./fogHelpers.js";

/**
 * One registry per runtime; it:
 *  - tracks all GlowManager instances
 *  - forwards config from GlowPanel ("EmitterTool:GlowConfig")
 *  - wires their cut containers to the fog holes once available
 */
export function createGlowRegistry({ appRef, pxPerMeterProvider }) {
  const gms = new Set();
  let holes = null;
  let lastCfg = null;

  const root = getRootContainer(appRef);

  function tryWireHoles() {
    if (holes && holes.destroyed) holes = null;
    if (!holes) holes = findFogHoles(root);
    if (!holes) return false;
    for (const gm of gms) {
      try { gm.setCutContainer(holes, { useEraseBlend: true }); } catch {}
    }
    return true;
  }

  function configureAll(effectSettingsMaybe, grid = {}) {
    // Keep metres→px consistent
    const ppm = typeof pxPerMeterProvider === "function" ? Number(pxPerMeterProvider()) : NaN;
    const gridMerged = { ...grid };
    if (Number.isFinite(ppm) && ppm > 0) gridMerged.pxPerMeter = ppm;

    lastCfg = effectSettingsMaybe ? { ...effectSettingsMaybe } : lastCfg;

    for (const gm of gms) {
      try { gm.configure(lastCfg || {}, gridMerged); } catch {}
    }
    tryWireHoles();
  }

  // Listen to the UI config bus from GlowPanel
  const onCfg = (ev) => {
    const d = ev?.detail || {};
    configureAll(d, {});
  };
  try { window.addEventListener("EmitterTool:GlowConfig", onCfg); } catch {}

  // Expose some debugging hooks
  try { window.__ET_GLOW_REG__ = { gms, configureAll, tryWireHoles }; } catch {}

  return {
    add(gm, initialEffectSettings = {}, grid = {}) {
      gms.add(gm);
      // initial configure
      configureAll({ ...(lastCfg || {}), ...(initialEffectSettings || {}) }, grid);
      // attempt to wire holes if present
      tryWireHoles();
      return gm;
    },
    remove(gm) {
      gms.delete(gm);
    },
    wireNow() { tryWireHoles(); },
    configureAll,
  };
}
